// extracted by mini-css-extract-plugin
module.exports = {"note":"styles_note__24dSh","note__wrapper":"styles_note__wrapper__1l9sH","isActive":"styles_isActive__El5Ej"};